import React, { FC } from 'react'
import {
  Grid,
  Box,
  Button,
  Modal,
  Select,
  MenuItem,
  Typography,
} from '@mui/material'
import { useChangeProgramDialog } from './useChangeProgramDialog'
import { map, sortBy } from 'lodash'
import { useChangeProgramDialogStyles } from './ChangeProgramDialog.styles'
import { formatCents } from '../../../../../../utils/currency-formatter'
import { Reservation } from '@nxcr-org/web-api-interface/lib/billing_service_pb'

export type ChangeProgramDialogProps = {
  onClose: () => void
  isOpen: boolean
  programId: string
  customerId: string
  reservation: Reservation.AsObject
  postal: string
}

export const ChangeProgramDialog: FC<ChangeProgramDialogProps> = ({
  onClose,
  isOpen,
  programId,
  customerId,
  reservation,
  postal,
}) => {
  const { classes } = useChangeProgramDialogStyles()
  const {
    programs,
    program,
    pricingId,
    setProgram,
    setPricingId,
    saveProgramSelection,
    isLoading,
    programPricingOptions,
    DEFAULT_PROGRAM_ID,
  } = useChangeProgramDialog({
    reservation,
    programId,
    customerId,
    onClose,
    postal,
  })

  return (
    <Modal open={isOpen} onClose={onClose}>
      {!isLoading && (
        <Box className={classes.base}>
          <Grid container size={{xs:12}}>
            <Grid>
              <Typography variant="h1">Switching Programs</Typography>
            </Grid>
            <div style={{ flex: 1 }} />
            <Grid>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => onClose()}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
          <Grid className={classes.body}>
            <Grid container spacing={2}>
              <Grid className={classes.programSection}>
                <Typography variant="caption">Program Type</Typography>
                <Select
                  value={program?.id || DEFAULT_PROGRAM_ID}
                  label="Program Type"
                  onChange={(evt) => setProgram(evt.target.value)}
                >
                  {map(sortBy(programs?.programsList, 'description'), (programOption) => {
                    return (
                      <MenuItem key={programOption.id} value={programOption.id}>
                        {programOption.description}
                      </MenuItem>
                    )
                  })}
                </Select>
              </Grid>
              <Grid className={classes.programSection}>
                <Typography variant="caption">Start Fee/Monthly Fee</Typography>
                <Select
                  displayEmpty
                  label="Start Fee/Monthly Fee"
                  value={pricingId}
                  onChange={(evt) => setPricingId(evt.target.value)}
                >
                  {map(programPricingOptions, (pricingOption) => {
                    return (
                      <MenuItem key={pricingOption.id} value={pricingOption.id}>
                        {formatCents(pricingOption.startFee)} /
                        {formatCents(pricingOption.monthlyRent)}
                      </MenuItem>
                    )
                  })}
                </Select>
              </Grid>
            </Grid>
            <Grid>
              <Typography className={classes.disclaimer}>
                By clicking Confirm Program Change, the customer acknowledges
                that switching programs may change their start fee, monthly fee,
                how long the current price is active, and other various fees.
                The customer also acknowledges that they must go through the CQE
                approval process again to qualify for this particular program.
              </Typography>
            </Grid>
            <Grid container justifyContent="center">
              <Button
                variant="outlined"
                color="primary"
                onClick={() => saveProgramSelection()}
              >
                Confirm Program Change
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </Modal>
  )
}
